<template>
  <div class="coupon-box">
    <el-button
      type="text"
      class="goback"
      icon="el-icon-back"
      @click.native="goBack"
      >Back</el-button
    >
    <el-table :data="couponList" v-loading="loading">
      <el-table-column label="ID" prop="id"></el-table-column>
      <el-table-column label="Title" prop="title"></el-table-column>
      <el-table-column label="With Amount" prop="with_amount">
        <template slot-scope="scope">
          {{ (scope.row.with_amount / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="Used Amount" prop="used_amount">
        <template slot-scope="scope">
          {{ (scope.row.used_amount / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="Valid End Time">
        <template slot-scope="scope">
          {{ scope.row.valid_end_time | formatTime }}
        </template>
      </el-table-column>
      <el-table-column label="Status">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 1" size="small"
            >Take Effect</el-tag
          >
          <el-tag type="info" v-if="scope.row.status === 2" size="small"
            >Invalid</el-tag
          >
          <el-tag type="info" v-if="scope.row.status === 3" size="small"
            >Used</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="Create Time">
        <template slot-scope="scope">
          {{ scope.row.create_time | formatTime }}
        </template>
      </el-table-column>
    </el-table>
    <KtPag
      style="text-align: right"
      :pageCount="pageParams.count"
      :currentPage="pageParams.page"
      :limit="pageParams.limit"
      @onChange="handleChange"
    ></KtPag>
  </div>
</template>

<script>
import KtPag from "@/views/Comm/KtPag";
import moment from "moment";
export default {
  components: {
    KtPag,
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid())
        return moment(val).format("DD/MM/YYYY/ HH:mm:ss");
      else return "-";
    },
  },
  data() {
    return {
      couponList: [],
      pageParams: { page: 1, limit: 5, count: 0 },
      c_id: "",
      loading: false,
    };
  },
  created() {
    this.c_id = this.$route.query.c_id;
  },
  mounted() {
    this.getCouponList(1);
  },
  methods: {
    handleChange({ page, limit }) {
      this.pageParams = Object.assign({}, this.pageParams, { page, limit });
      this.getCouponList(2);
    },
    goBack() {
      // window.history.back()
      this.$router.back(-1);
      //   this.$router.push("/myinfo/wallet");
    },
    contactPeople(id) {
      if (id) {
        let routeData = this.$router.resolve({
          path: "/chat?contactId=" + id,
        });
        window.open(routeData.href, "_blank");
      }
      //   this.chatVisible = true;
    },
    async getCouponList(type) {
      this.loading = true;
      let params = {};
      params["limit"] = this.pageParams.limit;
      if (type === 1) {
        params["page"] = 1;
      }
      params["page"] = this.pageParams.page;
      const { status, data, message } =
        await this.$api.accountApi.getCouponList(params);
      if (status === "0") {
        this.couponList = data.rows;
        this.pageParams.count = data.count;
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.coupon-box {
  padding: 24px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  .goback {
    color: #f48c06;
  }
  .myinfo-mid-content {
    // margin-top: vw(32);
    // box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    // border-radius: 24px;
    // background: #ffffff;
    .flex_1 {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      .fa-commenting-o {
        font-size: 24px;
        color: #f48c06;
        cursor: pointer;
      }
      .realnameimg {
        width: 12px;
        height: 12px;
        margin-right: 5px;
      }
      .realname {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
      }
      .price {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
      }
      .price_text {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f48c06;
      }
      .checkbt {
        color: #fff;
        border: none;
        outline: none;
        background: #f48c06;
        &:hover {
          opacity: 0.54;
        }
      }
    }
    .flex_5 {
      flex: 5;
    }
    .list-head {
      height: vh(40);
      line-height: vh(40);
      font-size: 18px;
      font-weight: 500;
      color: #181d2c;
      box-sizing: border-box;
      padding-left: vw(10);
    }
    .list-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: vh(120);
      padding: vh(24) 0;
      box-sizing: border-box;
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .info-img {
        width: 72px;
        height: 72px;
        border-radius: 8px;
        display: inline-block;
      }
      .info-detail {
        width: calc(100% - 72px);
        display: inline-block;
        padding-left: vw(16);
        box-sizing: border-box;
        .detail-title {
          height: vh(24);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: vh(24);
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .detail-content {
          height: vh(48);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: vh(24);
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>